module.exports = __webpack_public_path__ + "img/emm_icon05.5fedec86.png";